<div class="field-free-text-wrapper">

  <div class="free-text" *ngIf="!isInput">
    <span class="multiline-text-display">{{freeText}}</span>
  </div>

  <div class="free-text-input" *ngIf="isInput">
    <textarea type="text" class="form-control" [(ngModel)]="freeText" (ngModelChange)="onChange()"></textarea>
  </div>
</div>